module.exports = __webpack_public_path__ + "images/wertentwicklung_pos_FBB.svg?a21e2145743f5c4e3bfd51bbf3257f25";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/wertentwicklung_pos_FBB.svg
// module id = Ev0L
// module chunks = 0